const FLEXIBLE_NAMES_ONE = [
  'CITERDIAL',
  'LACTADIAL',
  'ALCODIAL',
  'VENDANGE',
  'VINITRELL',
  'MILLESIME',
  'TRELLVIN',
  'BERGALAV',
  'MULTIDIAL UPE',
];

const FLEXIBLE_NAMES_TWO = [
  'SUPERVRAC AL EC',
  'TRELLEVAC AL EC',
  'ALIKLER D',
  'ALIKLER G2',
  'BIOVAST',
  'BIOCLEAN',
  'KLENET',
];

const FLEXIBLE_NAMES_THREE = [
  'CITERDIAL',
  'LACTADIAL',
  'ALCODIAL',
  'VENDANGE',
  'VINITRELL',
  'SUPERVRAC AL EC',
  'TRELLEVAC AL EC',
  'ALIKLER D',
  'ALIKLER G2',
  'BIOVAST',
  'BIOCLEAN',
  'KLENET',
];

const FLEXIBLE_NAMES_FOUR = [
  'MILLESIME',
  'TRELLVIN',
  'BERGALAV',
  'MULTIDIAL UPE',
];

const FLEXIBLE_NAMES_FIVE = [
  'CITERDIAL',
  'LACTADIAL',
  'ALCODIAL',
  'VENDANGE',
  'VINITRELL',
];

const FLEXIBLE_NAMES_SIX = [
  'SUPERVRAC AL EC',
  'TRELLEVAC AL EC',
  'ALIKLER D',
  'ALIKLER G2',
  'BIOVAST',
  'BIOCLEAN',
  'KLENET',
];

function getAll() {
  const flexibleName = [];
  return flexibleName.concat(FLEXIBLE_NAMES_ONE).concat(FLEXIBLE_NAMES_TWO);
}

function hno3TemperatureFormula(temperature) {
  return temperature > 84;
}

function h3po4TemperatureFormula(temperature) {
  return temperature > 84;
}

function ccConcentrationFormula(concentration) {
  return concentration > 0.9;
}

function naohTemperatureFormula(temperature) {
  return temperature > 79;
}

function h2o2TemperatureFormula(temperature) {
  return temperature > 84;
}

function hno3FlexibleFilter(temperature, concentration) {
  let flexibleName = [];
  if (concentration > 3 || temperature > 85) {
    return false;
  }
  if (((-20.689 * concentration) + 87.0689) <= temperature) {
    flexibleName = flexibleName.concat(FLEXIBLE_NAMES_ONE).concat(FLEXIBLE_NAMES_TWO);
  }
  return flexibleName;
}

function h3po4FlexibleFilter(temperature, concentration) {
  let flexibleName = [];
  if (concentration > 3 || temperature > 85) {
    return false;
  }
  if (((-30 * concentration) + 115) <= temperature) {
    flexibleName = flexibleName.concat(FLEXIBLE_NAMES_ONE).concat(FLEXIBLE_NAMES_TWO);
  }
  return flexibleName;
}

function ccFlexibleFilter(temperature, concentration) {
  if (concentration > 1 || temperature > 70) {
    return false;
  }
  return FLEXIBLE_NAMES_ONE.concat(FLEXIBLE_NAMES_TWO);
}

function naohFlexibleFilter(temperature, concentration) {
  let flexibleName = [];
  if (concentration > 5 || temperature > 80) {
    return false;
  }
  if (temperature <= 60) {
    if (((-11.66 * concentration) + 83.333) <= temperature) {
      flexibleName = flexibleName.concat(FLEXIBLE_NAMES_TWO);
    }
  }
  if (((-18.333 * concentration) + 116.666) <= temperature) {
    flexibleName = flexibleName.concat(FLEXIBLE_NAMES_ONE);
  }
  return flexibleName;
}

function h2o2FlexibleFilter(temperature, concentration) {
  let flexibleName = [];
  if (concentration > 3 || temperature > 85) {
    return false;
  }
  if (temperature <= 25 && concentration <= 3) {
    flexibleName = flexibleName.concat(FLEXIBLE_NAMES_THREE);
  }
  if (((-40 * concentration) + 145) <= temperature) {
    flexibleName = flexibleName.concat(FLEXIBLE_NAMES_FOUR);
  }
  return flexibleName;
}

function c2h4o3FlexibleFilter(temperature, concentration) {
  let flexibleName = [];
  if (concentration > 1 || temperature > 50) {
    return false;
  }
  if (concentration <= 1) {
    if (temperature <= 25) {
      flexibleName = flexibleName.concat(FLEXIBLE_NAMES_SIX);
    }
    flexibleName = flexibleName.concat(FLEXIBLE_NAMES_FOUR);
  }
  if (temperature <= 25 && concentration <= 0.5) {
    flexibleName = flexibleName.concat(FLEXIBLE_NAMES_FIVE);
  }
  return flexibleName;
}

function warmWatterConditionValidate(temperature, duration, condition) {
  const warWatterCondition = JSON.parse(condition?.eau_chaude);
  return duration > warWatterCondition?.conditions[0]?.duration
    || temperature > warWatterCondition?.conditions[0]?.temperature;
}

function steamConditionValidate(temperature, duration, condition) {
  const steamCondition = JSON.parse(condition?.vapeur);
  return duration > steamCondition?.conditions[0]?.duration
    || temperature > steamCondition?.conditions[0]?.temperature;
}

export const nepApplies = {
  hno3: hno3FlexibleFilter,
  h3po4: h3po4FlexibleFilter,
  cc: ccFlexibleFilter,
  naoh: naohFlexibleFilter,
  h2o2: h2o2FlexibleFilter,
  c2h4o3: c2h4o3FlexibleFilter,
  warmWatter: getAll,
  steam: getAll
};

export {
  hno3TemperatureFormula,
  h3po4TemperatureFormula,
  naohTemperatureFormula,
  h2o2TemperatureFormula,
  ccConcentrationFormula,
  hno3FlexibleFilter,
  h3po4FlexibleFilter,
  ccFlexibleFilter,
  naohFlexibleFilter,
  h2o2FlexibleFilter,
  c2h4o3FlexibleFilter,
  warmWatterConditionValidate,
  steamConditionValidate
};
